import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import Logo from "./Logo";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/login");
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/members");
      })
      .catch(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/login");
      });
  }, [navigate]);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-ink" data-testid="auth-callback">
      <Logo size={52} />
      <Loader2 size={26} className="animate-spin text-silver-muted" />
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-silver-muted">Signing you in…</p>
    </main>
  );
}
